/* tslint:disable */
/* eslint-disable */
/**
 * back-office-service
 * Back Office Service
 *
 * The version of the OpenAPI document: 0.27.85
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PromotionCampaignFilters } from './PromotionCampaignFilters';
import {
    PromotionCampaignFiltersFromJSON,
    PromotionCampaignFiltersFromJSONTyped,
    PromotionCampaignFiltersToJSON,
} from './PromotionCampaignFilters';
import type { RedemptionLimitFrequency } from './RedemptionLimitFrequency';
import {
    RedemptionLimitFrequencyFromJSON,
    RedemptionLimitFrequencyFromJSONTyped,
    RedemptionLimitFrequencyToJSON,
} from './RedemptionLimitFrequency';
import type { PromotionCampaignTrigger } from './PromotionCampaignTrigger';
import {
    PromotionCampaignTriggerFromJSON,
    PromotionCampaignTriggerFromJSONTyped,
    PromotionCampaignTriggerToJSON,
} from './PromotionCampaignTrigger';
import type { PromotionCampaignAward } from './PromotionCampaignAward';
import {
    PromotionCampaignAwardFromJSON,
    PromotionCampaignAwardFromJSONTyped,
    PromotionCampaignAwardToJSON,
} from './PromotionCampaignAward';

/**
 * Back-office request type for updating an existing promotion campaign.
 * Mirrors GDS PromotionCampaignUpdateRequest but uses string for date fields —
 * the controller converts these to timezone-aware Date objects before proxying to GDS.
 * @export
 * @interface BackOfficePromotionCampaignUpdateRequest
 */
export interface BackOfficePromotionCampaignUpdateRequest {
    /**
     * 
     * @type {number}
     * @memberof BackOfficePromotionCampaignUpdateRequest
     */
    priority?: number | null;
    /**
     * 
     * @type {PromotionCampaignAward}
     * @memberof BackOfficePromotionCampaignUpdateRequest
     */
    awardConfig?: PromotionCampaignAward;
    /**
     * 
     * @type {RedemptionLimitFrequency}
     * @memberof BackOfficePromotionCampaignUpdateRequest
     */
    redemptionLimitFrequency?: RedemptionLimitFrequency | null;
    /**
     * 
     * @type {PromotionCampaignFilters}
     * @memberof BackOfficePromotionCampaignUpdateRequest
     */
    filters?: PromotionCampaignFilters | null;
    /**
     * 
     * @type {number}
     * @memberof BackOfficePromotionCampaignUpdateRequest
     */
    triggerCount?: number;
    /**
     * 
     * @type {PromotionCampaignTrigger}
     * @memberof BackOfficePromotionCampaignUpdateRequest
     */
    trigger?: PromotionCampaignTrigger;
    /**
     * 
     * @type {string}
     * @memberof BackOfficePromotionCampaignUpdateRequest
     */
    endAt?: string | null;
    /**
     * 
     * @type {string}
     * @memberof BackOfficePromotionCampaignUpdateRequest
     */
    startAt?: string | null;
    /**
     * 
     * @type {string}
     * @memberof BackOfficePromotionCampaignUpdateRequest
     */
    description?: string | null;
    /**
     * 
     * @type {string}
     * @memberof BackOfficePromotionCampaignUpdateRequest
     */
    name?: string;
}



/**
 * Check if a given object implements the BackOfficePromotionCampaignUpdateRequest interface.
 */
export function instanceOfBackOfficePromotionCampaignUpdateRequest(value: object): value is BackOfficePromotionCampaignUpdateRequest {
    return true;
}

export function BackOfficePromotionCampaignUpdateRequestFromJSON(json: any): BackOfficePromotionCampaignUpdateRequest {
    return BackOfficePromotionCampaignUpdateRequestFromJSONTyped(json, false);
}

export function BackOfficePromotionCampaignUpdateRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): BackOfficePromotionCampaignUpdateRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'priority': json['priority'] == null ? undefined : json['priority'],
        'awardConfig': json['awardConfig'] == null ? undefined : PromotionCampaignAwardFromJSON(json['awardConfig']),
        'redemptionLimitFrequency': json['redemptionLimitFrequency'] == null ? undefined : RedemptionLimitFrequencyFromJSON(json['redemptionLimitFrequency']),
        'filters': json['filters'] == null ? undefined : PromotionCampaignFiltersFromJSON(json['filters']),
        'triggerCount': json['triggerCount'] == null ? undefined : json['triggerCount'],
        'trigger': json['trigger'] == null ? undefined : PromotionCampaignTriggerFromJSON(json['trigger']),
        'endAt': json['endAt'] == null ? undefined : json['endAt'],
        'startAt': json['startAt'] == null ? undefined : json['startAt'],
        'description': json['description'] == null ? undefined : json['description'],
        'name': json['name'] == null ? undefined : json['name'],
    };
}

export function BackOfficePromotionCampaignUpdateRequestToJSON(value?: BackOfficePromotionCampaignUpdateRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'priority': value['priority'],
        'awardConfig': PromotionCampaignAwardToJSON(value['awardConfig']),
        'redemptionLimitFrequency': RedemptionLimitFrequencyToJSON(value['redemptionLimitFrequency']),
        'filters': PromotionCampaignFiltersToJSON(value['filters']),
        'triggerCount': value['triggerCount'],
        'trigger': PromotionCampaignTriggerToJSON(value['trigger']),
        'endAt': value['endAt'],
        'startAt': value['startAt'],
        'description': value['description'],
        'name': value['name'],
    };
}

